import { AxiosError, AxiosResponse } from "axios";
import { NavigateFunction } from "react-router-dom";
import { createApi } from "../../../utils/createApi";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { VlmConfigPatchBody, VlmConfigResponse } from "./vlmConfigTypes";

export const patchCameraVlmConfig = (
  cameraId: string | number,
  patchBody: VlmConfigPatchBody,
  navigate: NavigateFunction
): Promise<VlmConfigResponse | null> => {
  const AxiosUI = createApi("");

  const retryFunction = () =>
    patchCameraVlmConfig(cameraId, patchBody, navigate);

  return AxiosUI.patch(`/camera/${cameraId}/vlm_config/`, patchBody)
    .then((response: AxiosResponse<VlmConfigResponse>) => response.data)
    .catch((reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      return null;
    });
};
